export const iconSize = {
  s: 'xs',
  l: 's'
};